import PropTypes from 'prop-types';
import './Icono.scss';

const Icono = ({ iconName, size, color, paddingLeft, paddingTop, paddingRight }) => {
  const style = {
    fontSize: size,
    color,
    paddingLeft,
    paddingTop,
    paddingRight
  };

  return (
    <span className="material-icons" style={style}>
      {iconName}
    </span>
  );
};

export default Icono;

Icono.propTypes = {
  iconName: PropTypes.string.isRequired,
  size: PropTypes.number,
  color: PropTypes.string,
  paddingLeft: PropTypes.number,
  paddingTop: PropTypes.number,
  paddingRight: PropTypes.number
};

Icono.defaultProps = {
  size: 24,
  color: 'white',
  paddingLeft: 0,
  paddingTop: 0,
  paddingRight: 0
};
